import { render, staticRenderFns } from "./PortfolioDetails.vue?vue&type=template&id=ddd2d17c&scoped=true&"
import script from "./PortfolioDetails.vue?vue&type=script&lang=js&"
export * from "./PortfolioDetails.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioDetails.vue?vue&type=style&index=0&id=ddd2d17c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd2d17c",
  null
  
)

export default component.exports